import React from "react";

const pagnes = [
  {
    id: "pagne-dandali",
    img: "/images/pagne-dandali3.png",
    badge: "TRADITIONNEL",
    title: "Pagne du Dandali",
    desc: "Tissu riche et raffiné pour les festivités traditionnelles du Mercredi.",
    alt: "Pagne du Dandali — tissu bordeaux et or",
  },
  {
    id: "pagne-yaayi",
    img: "/images/pagne-yaayi.jpg",
    badge: "CÉRÉMONIE",
    title: "Pagne du Yaayi",
    desc: "Tissu wax éclatant choisi comme Yaayi.",
    alt: "Pagne du Yaayi — wax orange et or",
  },
];

// WhatsApp phone — international format without leading + or spaces for wa.me
const WHATSAPP_NUMBER = "24102373400"; // +241 02 37 34 00
const WHATSAPP_MESSAGE = encodeURIComponent(
  "Coucou Salma, je souhaite commander le pagne pour le mariage de Yero et Maimouna"
);

export default function Pagnes() {
  return (
    <section
      id="pagnes"
      data-testid="pagnes-section"
      className="relative section-pad"
    >
      <div className="max-w-5xl mx-auto px-2">
        <div className="text-center mb-14">
          <p className="gold-rule mb-6">LES PAGNES DU MARIAGE</p>
          <h2 className="font-serif-display text-emerald-deep text-4xl md:text-5xl">
            Tissus &amp; couleurs des cérémonies
          </h2>
          <p className="font-serif-display italic text-emerald/80 mt-3 max-w-2xl mx-auto">
            Les tissus sélectionnés pour porter nos couleurs le jour J.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {pagnes.map(({ id, img, badge, title, desc, alt }) => (
            <article
              key={id}
              data-testid={id}
              className="relative bg-cream border border-[#C9A961]/50 p-5 md:p-6 shadow-[0_20px_50px_-25px_rgba(10,61,46,0.45)] flex flex-col"
            >
              <div
                className="relative overflow-hidden border border-[#C9A961]/40"
                style={{ backgroundColor: "#F7EEDC", aspectRatio: "4 / 5" }}
              >
                <img
                  src={img}
                  alt={alt}
                  loading="lazy"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="mt-5 text-center flex flex-col items-center">
                <p className="text-gold tracking-[0.4em] text-xs">{badge}</p>
                <h3 className="font-serif-display text-emerald-deep text-2xl md:text-3xl mt-2">
                  {title}
                </h3>
                <div className="divider-ornament my-3">
                  <span className="line" />
                  <span className="dot" />
                  <span className="line" />
                </div>
                <p className="font-serif-display italic text-emerald/80 px-2">
                  {desc}
                </p>
              </div>
            </article>
          ))}
        </div>

        {/* Order pagne via WhatsApp */}
        <div className="mt-12 text-center" data-testid="pagne-order">
          <p className="font-serif-display italic text-emerald/80 max-w-xl mx-auto mb-5">
            Pour vous procurer le pagne, contactez-nous directement :
          </p>
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`}
            target="_blank"
            rel="noreferrer"
            data-testid="pagne-whatsapp-cta"
            className="inline-flex items-center gap-3 px-7 py-3 rounded-full transition-transform duration-300 hover:-translate-y-0.5"
            style={{
              background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
              color: "white",
              boxShadow: "0 12px 30px -10px rgba(18,140,126,0.55)",
              letterSpacing: "0.15em",
              fontSize: "13px",
              fontWeight: 600,
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden
            >
              <path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.82 11.82 0 0 1 8.413 3.488 11.82 11.82 0 0 1 3.48 8.414c-.003 6.554-5.338 11.89-11.893 11.89a11.9 11.9 0 0 1-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 0 0 1.668 5.39l-.99 3.624 3.811-1.713zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
            </svg>
            COMMANDER VIA WHATSAPP
          </a>
          <p className="text-gold tracking-[0.3em] text-[11px] mt-4">
            +241 02 37 34 00
          </p>
        </div>

        <p className="text-center mt-10 text-gold tracking-[0.4em] text-xs">
          ✦ MERCI DE PORTER NOS COULEURS LE JOUR J ✦
        </p>
      </div>
    </section>
  );
}
